export default __webpack_public_path__ + "static/waluta-bg-main-18a7ba612f8b7f9cbe9ddeddec09e736.png";